import { isNil } from 'lodash';
import { ControlOption } from '@shared/components/filter/types';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';

interface UseConditionTypeOptionsProps {
  component: API.DateComponent;
}

export function useConditionTypeOptions({
  component,
}: UseConditionTypeOptionsProps): ControlOption[] {
  const hasDefaultAutoExtend =
    !isNil(component?.autoExtendDefault?.minimumInSeries) &&
    !isNil(component?.autoExtendDefault?.impliedFilterComponentId);

  const defaultOption = {
    id: 'default',
    label: i18n('workflowTemplate.component.dateAndRepeat.autoExtend.onSchedule'),
  };

  const customOption = {
    id: 'custom',
    label: i18n('workflowTemplate.component.dateAndRepeat.autoExtend.customize'),
  };

  return [...(hasDefaultAutoExtend ? [defaultOption] : []), customOption];
}
